import { Box, Typography } from "@mui/material";
import { PercentageChangeIndicator } from "Components/Merchant/FeeCalculator/PercentageChangeIndicator";
import { formatCurrency } from "Utils/CurrencyUtils";

type Props = {
  label: string;
  amount: number;
  percentage: number;
};

export const SavingReport = ({ label, amount, percentage }: Props) => (
  <Box display="flex" flexWrap="wrap" gap={1}>
    <Typography fontSize="1.2rem" display="flex" alignItems="center">
      {label}
    </Typography>
    <Typography fontSize="1.2rem" display="flex" flexWrap="wrap">
      <Typography
        component="strong"
        fontWeight="bold"
        fontSize="1.5rem"
        ml={1}
        mr={2}
      >
        {formatCurrency({
          amount,
          currencyCode: "CZK",
          maxDecimalPlaces: 0,
        })}
      </Typography>
      <Typography
        component="span"
        fontSize="1.2rem"
        display="flex"
        alignItems="center"
      >
        <PercentageChangeIndicator percentage={percentage} />
      </Typography>
    </Typography>
  </Box>
);
